export const commonUserType = {
  USER: 'USER',
  SERVICE: 'SERVICE',
};
